(function () {
	const collectionSlider = () => {
		$(".section-collection-slider").each(function () {
			if ($(this).hasClass("slider_started")) {
				return "";
			}
			$(this).addClass("slider_started");
			const id = $(this).attr("id");
			const box = $(this).find(".collection_slider");
			const speed = box.data("speed") * 1000;
			const autoplay = box.data("autoplay");
			const stopAutoplay = box.data("stop-autoplay");
			const delay = box.data("delay") * 1000;
			if (autoplay) {
				box.find(".collection-pagination span").addClass("autoplay-active");
			}
			let autoplayParm = autoplay
				? {
						autoplay: {
							delay: delay,
							disableOnInteraction: false,
						},
				  }
				: {};

			let swiperParms = {
				effect: "slide",
				speed: box.data("speed") * 1000,
				slidesPerView: 1,
				spaceBetween: 0,
				autoHeight: false,
				calculateHeight: false,
				keyboard: true,
				mousewheel: {
					forceToAxis: true,
				},
			};
			const swiperImg = new Swiper(`#${id} .swiper_image_block`, {
				slidesPerView: 1,

				navigation: {
					nextEl: `#${id} .swiper-btn--next`,
					prevEl: `#${id} .swiper-btn--prev`,
				},
				pagination: {
					el: `#${id} .swiper-pagination`,
					renderBullet: function (index, className) {
						return (
							'<span class="' + className + '">' + "0" + (index + 1) + "</span>"
						);
					},
				},
				on: {
					init: function () {},
					slideChangeTransitionStart: function (swiper) {
						let bullets = document.querySelectorAll(
							`#${id} .swiper-pagination-bullet`
						);
						let activeIndex = swiper.realIndex;
		
							bullets.forEach((bullet, index) => {
								bullet.classList.remove("prev", "next");
								if (index === activeIndex - 1) {
									bullet.classList.add("prev");
								}
								if (index === activeIndex + 1) {
									bullet.classList.add("next");
								}
							});
						
						
					},
					slideNextTransitionStart: function () {
            let bullets = document.querySelector(
                `#${id} .swiper-pagination-bullet.next`
            );
					 let x =	document.querySelectorAll(`#${id} .swiper-pagination-bullet`)
						
						if(autoplay) {
							if (bullets) {
									bullets.classList.add('opacity-0');
									setTimeout(() => {
											bullets.classList.remove('opacity-0');
									}, speed);
							}
				
							
							if (x[x.length - 1].classList.contains('swiper-pagination-bullet-active') && x.length == 3)   {

								
								setTimeout(() => {
									x[1].classList.remove('prev')
									//x[x.length - 1].classList.add('prev')
							}, speed);
							}
						}
				
        },
				slidePrevTransitionStart: function () {
					let bullets = document.querySelector(
							`#${id} .swiper-pagination-bullet.prev`
					);
					if(!autoplay) {
						if (bullets) {
								bullets.classList.add('opacity-0');
								setTimeout(() => {
										bullets.classList.remove('opacity-0');
								}, speed);
						}
					}
			},
				},
				...autoplayParm,
				...swiperParms,



				effect: "fade",
				creativeEffect: {
					prev: { shadow: true, translate: [0, 0, -1] },
					next: { translate: ["100%", 0, 0] },
				},
			});
			const swiperText = new Swiper(`#${id} .swiper_product_block`, {
				...swiperParms,
	
				
				slidesPerView: 1.2,
			});
		
		



			swiperImg.controller.control = swiperText;
			swiperText.controller.control = swiperImg;

			if (autoplay && stopAutoplay) {
				document
					.querySelector(`#${id} .collection_slider`)
					.addEventListener("mouseenter", function () {
						swiperText.autoplay.stop();
						swiperImg.autoplay.stop();
					});
				document
					.querySelector(`#${id} .collection_slider`)
					.addEventListener("mouseleave", function () {
						swiperText.autoplay.start();
					});
			}
		});
	};

	collectionSlider()
	document.addEventListener('shopify:section:load', function () {
		collectionSlider()
	})
})();
